import type {TuiCountryIsoCode, TuiLanguage, TuiLanguageCommerce, TuiLanguageCore, TuiLanguageEditor, TuiLanguageKit, TuiLanguageLayout, TuiLanguageTable} from '@taiga-ui/i18n/types';

export const TUI_ROMANIAN_LANGUAGE_ADDON_COMMERCE: TuiLanguageCommerce = {
    cardNumber: ['Număr', 'Număr card'],
    cardExpiry: ['Expirare', 'Data expirării'],
};

export const TUI_ROMANIAN_LANGUAGE_LAYOUT: TuiLanguageLayout = {
    inputSearch: {
        popular: 'Popular',
        history: 'Recent',
        placeholder: 'Căutare',
        hotkey: 'pentru căutare',
        all: 'Toate',
        empty: 'Niciun rezultat',
    },
};

export const TUI_ROMANIAN_LANGUAGE_KIT: TuiLanguageKit = {
    cancel: 'Anulare',
    done: 'Gata',
    more: 'Mai mult',
    otherDate: 'Altă dată...',
    showAll: 'Afișează tot',
    hide: 'Ascunde',
    mobileCalendarTexts: [
        'Selectați ziua',
        'Selectați perioada',
        'Selectați zile',
    ],
    range: ['De la', 'Până la'],
    countTexts: ['Mai mult', 'Mai puțin'],
    time: {
        'HH:MM': 'HH:MM',
        'HH:MM AA': 'HH:MM AA',
        'HH:MM:SS': 'HH:MM:SS',
        'HH:MM:SS AA': 'HH:MM:SS AA',
        'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
        'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA',
    },
    dateTexts: {
        DMY: 'zi.lună.an',
        MDY: 'lună.zi.an',
        YMD: 'an.lună.zi',
    },
    digitalInformationUnits: ['Byte', 'Kilobyte', 'Megabyte'],
    passwordTexts: ['Afișează parola', 'Ascunde parola'],
    copyTexts: ['Copiază', 'Copiat'],
    shortCalendarMonths: [
        'Ian',
        'Feb',
        'Mar',
        'Apr',
        'Mai',
        'Iun',
        'Iul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ],
    pagination: ['Pagina anterioară', 'Pagina următoare'],
    fileTexts: {
        loadingError: 'Eroare la încărcare',
        preview: 'Previzualizare',
        remove: 'Șterge',
    },
    inputFileTexts: {
        defaultLabelSingle: 'sau trageți aici',
        defaultLabelMultiple: 'sau trageți-le aici',
        defaultLinkSingle: 'Selectați fișier',
        defaultLinkMultiple: 'Selectați fișiere',
        maxSizeRejectionReason: 'Fișierul este prea mare',
        formatRejectionReason: 'Format fișier invalid',
        drop: 'Trageți fișierul aici',
        dropMultiple: 'Trageți fișierele aici',
    },
    multiSelectTexts: {
        all: 'Selectează tot',
        none: 'Deselectează tot',
    },
    confirm: {
        yes: 'Da',
        no: 'Nu',
    },
    previewTexts: {
        rotate: 'Rotește',
    },
    zoomTexts: {
        zoomOut: 'Micșorează',
        zoomIn: 'Mărește',
        reset: 'Resetează',
    },
    phoneSearch: 'Căutați țară sau cod',
};

export const TUI_ROMANIAN_LANGUAGE_ADDON_EDITOR: TuiLanguageEditor = {
    colorSelectorModeNames: ['Culoare unică', 'Gradient de culoare'],
    toolbarTools: {
        undo: 'Anulează',
        redo: 'Refă',
        font: 'Font',
        fontStyle: 'Stil font',
        fontSize: 'Dimensiune font',
        bold: 'Îngroșat',
        italic: 'Cursiv',
        underline: 'Subliniat',
        strikeThrough: 'Tăiat',
        justify: 'Aliniere',
        justifyLeft: 'Aliniere la stânga',
        justifyCenter: 'Aliniere la centru',
        justifyRight: 'Aliniere la dreapta',
        justifyFull: 'Aliniere pe toată lățimea',
        list: 'Listă',
        indent: 'Crește indentarea',
        outdent: 'Scade indentarea',
        unorderedList: 'Listă neordonată',
        orderedList: 'Listă ordonată',
        quote: 'Citat',
        foreColor: 'Culoare text',
        backColor: 'Culoare fundal',
        hiliteColor: 'Culoare evidențiere',
        clear: 'Curăță',
        link: 'Link',
        attach: 'Atașează fișier',
        tex: 'Inserează TeX',
        code: 'Cod',
        image: 'Inserează imagine',
        insertHorizontalRule: 'Inserează linie orizontală',
        superscript: 'Superscript',
        subscript: 'Subscript',
        insertTable: 'Inserează tabel',
        insertGroup: 'Inserează grup',
        hiliteGroup: 'Evidențiază grup',
        removeGroup: 'Șterge grup',
        insertAnchor: 'Inserează ancoră',
        mergeCells: 'Unește celule',
        splitCells: 'Desparte celule',
        rowsColumnsManaging: 'Gestionare rânduri și coloane',
        cellColor: 'Culoare celulă',
        setDetails: 'Setează detalii',
        removeDetails: "Șterge detalii",
    },
    editorEditLink: {
        urlExample: 'exemplu.com',
        anchorExample: 'ancoră',
    },
    editorTableCommands: [
        ['Inserează coloană înainte', 'Inserează coloană după'],
        ['Inserează rând înainte', 'Inserează rând după'],
        ['Șterge coloană', 'Șterge rând'],
    ],
    editorCodeOptions: ['Cod în text', 'Bloc de cod'],
    editorFontOptions: {
        small: 'Mic',
        large: 'Mare',
        normal: 'Normal',
        title: 'Titlu',
        subtitle: 'Subtitlu',
    },
};

export const TUI_ROMANIAN_LANGUAGE_ADDON_TABLE: TuiLanguageTable = {
    showHideText: 'Afișează/Ascunde',
    paginationTexts: {
        pages: 'Pagini',
        linesPerPage: 'Linii pe pagină',
        of: 'din',
    },
};

export const TUI_ROMANIAN_LANGUAGE_CORE: TuiLanguageCore = {
    months: [
        'Ianuarie',
        'Februarie',
        'Martie',
        'Aprilie',
        'Mai',
        'Iunie',
        'Iulie',
        'August',
        'Septembrie',
        'Octombrie',
        'Noiembrie',
        'Decembrie',
    ],
    close: 'Închide',
    clear: 'Curăță',
    nothingFoundMessage: 'Niciun rezultat',
    defaultErrorMessage: 'Valoare invalidă',
    spinTexts: ['Anterior', 'Următor'],
    shortWeekDays: ['Lun', 'Mar', 'Mie', 'Joi', 'Vin', 'Sâm', 'Dum'],
    countries: {} as Record<TuiCountryIsoCode, string>,
};

export const TUI_ROMANIAN_LANGUAGE: TuiLanguage = {
    name: 'romanian',
    ...TUI_ROMANIAN_LANGUAGE_CORE,
    ...TUI_ROMANIAN_LANGUAGE_KIT,
    ...TUI_ROMANIAN_LANGUAGE_ADDON_TABLE,
    ...TUI_ROMANIAN_LANGUAGE_ADDON_COMMERCE,
    ...TUI_ROMANIAN_LANGUAGE_ADDON_EDITOR,
    ...TUI_ROMANIAN_LANGUAGE_LAYOUT,
};